import { useSessionStore } from '@/entities/session';
import { Icon } from '@/shared/assets/icons';
import { Button, registerModal, Typography } from '@/shared/ui';
import { useModal } from '@ebay/nice-modal-react';

const LogoutDialog = () => {
  const hideModal = useModal().hide;
  const logout = useSessionStore((state) => state.logout);

  const onLogout = async () => {
    try {
      await logout();
    } finally {
      hideModal();
    }
  };

  return (
    <div className="flex w-[416px] flex-col gap-y-6">
      <div className="flex items-center gap-x-4">
        <Icon
          name="exclamation-circle"
          className="text-volcano-4"
          width={22}
          height={22}
        />

        <Typography variant="h5" className="font-medium opacity-85">
          Are you sure you want to log out?
        </Typography>
      </div>

      <div className="flex gap-x-2">
        <Button fullWidth variant="secondary" onClick={hideModal}>
          Cancel
        </Button>

        <Button fullWidth onClick={onLogout}>
          Log Out
        </Button>
      </div>
    </div>
  );
};

export const LogoutModal = registerModal(LogoutDialog);
